import React from "react";
import * as Components from "components";

// local images
import image_logo from "../assets/logo/Logo_NoBackground_red2.png";

const CombinedHelmetNHeader = () => (
  <>
    <Components.CustomHelmet image_logo={image_logo} />
    <Components.CustomHeader image_logo={image_logo} />
  </>
);

export default CombinedHelmetNHeader;
